/**
 * questIcons — SVG-иконки экрана «Квесты и слоты» (эталон screen-17-quests.js
 * I()/iCheck…iCode, js:56-63). Все — stroke currentColor, размер через проп w.
 */
import type { ReactNode } from "react";

const svg = (w: number, sw: number, paths: ReactNode) => (
  <svg width={w} height={w} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={sw}>
    {paths}
  </svg>
);

export const CheckIco = ({ w = 12 }: { w?: number }) => svg(w, 2.4, <path d="M4 12l6 6L20 7" />);

export const CrossIco = ({ w = 14 }: { w?: number }) => svg(w, 2, <path d="M5 5l14 14M19 5L5 19" />);

export const PlusIco = ({ w = 11 }: { w?: number }) => svg(w, 2, <path d="M12 5v14M5 12h14" />);

export const BoltIco = ({ w = 12 }: { w?: number }) => svg(w, 2, <path d="M13 2L5 13h6l-1 9 8-11h-6z" />);

export const LinkIco = ({ w = 11 }: { w?: number }) =>
  svg(w, 2, <path d="M9 15l6-6M8 12l-3 3a4 4 0 0 0 6 6l2-3M16 12l3-3a4 4 0 0 0-6-6l-2 3" />);

export const MoonIco = ({ w = 8 }: { w?: number }) =>
  svg(w, 2, <path d="M15 3a8 8 0 1 0 6 13c-6 1.5-9.5-5-6-13z" />);

export const GlobeIco = ({ w = 12 }: { w?: number }) =>
  svg(w, 2, <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3.5 3 14 0 18-3-4-3-14.5 0-18z" /></>);

export const SparkIco = ({ w = 10 }: { w?: number }) =>
  svg(w, 2, <>
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
    <path d="M18.5 15.5l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z" />
  </>);

export const CodeIco = ({ w = 12 }: { w?: number }) =>
  svg(w, 2, <><path d="M8 6l-5 6 5 6M16 6l5 6-5 6" /><path d="M13.5 4l-3 16" /></>);

/** Двойной шеврон кнопки «развернуть всё» (.qexp, эталон js:218). */
export const DoubleChevIco = ({ w = 14 }: { w?: number }) =>
  svg(w, 2.2, <><path d="M6 5l6 5 6-5" /><path d="M6 13l6 5 6-5" /></>);
